// Silent-in-production debug logger.
// Use for verbose developer breadcrumbs that shouldn't clutter prod DevTools
// (e.g. "parse error body failed", "sync probe failed", CMS internal tracing).
// For real errors that need production visibility, keep `console.error/warn`.

const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

export const devLog = {
  debug: (...args) => {
    if (isDev) console.debug(...args); // eslint-disable-line no-console
  },
  info: (...args) => {
    if (isDev) console.info(...args); // eslint-disable-line no-console
  },
};

export default devLog;
